<template>
  <nav class="navbar navbar-expand-md  main-nav">
    <div class="container">
      <!-- Brand -->
      <a class="navbar-brand" href="https://ovvyapp.com"><img src="~@/assets/img/logo.png" class="img img-fluid"></a>

      <!-- Toggler/collapsibe Button -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"><img src="~@/assets/img/menu.png" class="img img-fluid"></span>
      </button>

      <!-- Navbar links -->
      <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="https://ovvyapp.com">Home</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" href="#about">About Us</a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link" :href="$root.service_url">Services</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" href="#tutorial">Tutorial</a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link" :href="$root.service_url + '#deals'">Promo/Deals</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :href="$root.merchant_url">Merchant </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://ovvyapp.com/faq/">FAQ</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://ovvyapp.com/ovvy-blog/">Blog</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :href="$root.service_url + 'welcome'">Login / Sign Up</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "BaseHeader"
  }
</script>

<style scoped>

</style>
